import Home from "../screens/Home";
import Login from "../screens/Login";
import Search from "../screens/Search";

interface RouteType {
  path: string;
  component: any;
  name: string;
  protected: boolean;
}

const routes: RouteType[] = [
  {
    path: "",
    component: Home,
    name: "Home Screen",
    protected: true,
  },
  {
    path: "/login",
    component: Login,
    name: "Login Screen",
    protected: false,
  },
  {
    path: "/search",
    component: Search,
    name: "Search Screen",
    protected: true,
  },
];

export default routes;
